<div class="modal-header">
  <h4 class="modal-title">patient details</h4>
</div>
<div class="modal-body">
  <div class="container">
    <!-- <p>Whome would you like to book for ?</p> -->
    <form [formGroup]="requestForm">
      <form formGroupName="detailsDto">
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-12">
            <label>First Name</label>
            <input
              type="text"
              class="form-control"
              formControlName="firstName"
            />
            <div
              *ngIf="
                !requestForm.get('detailsDto.firstName').valid &&
                requestForm.get('detailsDto.firstName').touched
              "
            >
              <small class="error">Firstname should not be empty</small>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <label>Last Name:</label>
            <input
              type="text"
              class="form-control"
              formControlName="lastName"
            />
            <div
              *ngIf="
                !requestForm.get('detailsDto.lastName').valid &&
                requestForm.get('detailsDto.lastName').touched
              "
            >
              <small class="error">Lastname should not be empty</small>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-12">
            <label>DOB:</label>
            <input
              type="date"
              class="form-control"
              formControlName="dob"
              placeholder="DD/MM/YYYY"
              min="1920-01-01"
              max="{{ maxdate | date: 'yyyy-MM-dd' }}"
            />
            <div
              *ngIf="
                !requestForm.get('detailsDto.dob').valid &&
                requestForm.get('detailsDto.dob').touched
              "
            >
              <small class="error">Please fill the DOB</small>
            </div>
          </div>

          <div class="col-lg-6 col-md-6 col-sm-12">
            <label for="gen">Gender:</label>
            <select
              id="gen"
              name="rel"
              class="form-control"
              formControlName="genderId"
            >
              <option value="null" disabled>select</option>
              <ng-container *ngFor="let gender of gender">
                <option value="{{ gender?.genderId }}">
                  {{ gender?.genderName }}
                </option>
              </ng-container>
            </select>
            <div
              *ngIf="
                !requestForm.get('detailsDto.genderId').valid &&
                requestForm.get('detailsDto.genderId').touched
              "
            >
              <small class="error">Please select the gender</small>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-12">
            <label for="rel">Phone:</label>
            <input
              type="text"
              class="form-control"
              maxlength="10"
              placeholder="Enter phone number"
              formControlName="phoneNumber"
            />
            <div
              *ngIf="
                !requestForm.get('detailsDto.phoneNumber').valid &&
                requestForm.get('detailsDto.phoneNumber').touched
              "
            >
              <small class="error">Please enter phone number</small>
            </div>
          </div>

          <div class="col-lg-6 col-md-6 col-sm-12">
            <label for="rel">Email:</label>
            <input
              type="email"
              class="form-control"
              name="email"
              placeholder="Enter email"
              formControlName="email"
            />
            <div
              *ngIf="
                !requestForm.get('detailsDto.email').valid &&
                  requestForm.get('detailsDto.email').touched;
                else err
              "
            >
              <small class="error">Please enter email</small>
            </div>
            <ng-template #err>
              <div
                *ngIf="
                  requestForm.get('detailsDto.email').hasError('pattern') &&
                  requestForm.get('detailsDto.email').touched
                "
              >
                <small class="error">Please enter valid email</small>
              </div>
            </ng-template>
          </div>
        </div>
      </form>
      <p>What mode of consultation would you prefer ?</p>
      <div class="btn-group">
        <button
          type="button"
          class="btn"
          [ngClass]="typeMode == 'Video' ? 'Col_Green' : 'Col_Grey'"
          (click)="getValues({ mode: 'Video' })"
        >
          Video
        </button>
      </div>
      <!-- <div class="btn-group">
        <button type="button" class="btn" [ngClass]="typeMode == 'Audio'? 'Col_Green':'Col_Grey'"
          (click)="getValues({mode :'Audio'})">Audio</button>
      </div>
      <div class="btn-group">
        <button type="button" class="btn" [ngClass]="typeMode == 'Email'? 'Col_Green':'Col_Grey'"
          (click)="getValues({mode :'Email'})">Email</button>
      </div> -->
      <div
        *ngIf="
          !requestForm.get('modeOfConsultation').valid &&
          requestForm.get('modeOfConsultation').touched
        "
      >
        <small class="error outside_Div"
          >Select the mode of consult to doctor</small
        >
      </div>
      <p>
        Would you like to book an appointment just now or schedule it at another
        time ?
      </p>
      <!-- <p>We are available from Monday to Sunday 6:00 AM to 10:00 PM</p> -->
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="btn-group">
            <input
              formControlName="appointmentDate"
              (click)="openModal(appointmentSchduler)"
            />
            <div
              *ngIf="
                !requestForm.get('appointmentDate').valid &&
                requestForm.get('appointmentDate').touched
              "
            >
              <small class="error">Appointment date should not be empty</small>
            </div>
          </div>
        </div>
      </div>
      <div class="boxleft">
        <label>Additional Info</label>
        <div class="form-group">
          <textarea
            class="form-control"
            id="exampleFormControlTextarea5"
            rows="7"
            formControlName="additionalInfo"
          ></textarea>
        </div>
      </div>
      <button type="button" class="btn btn-default" (click)="submitReq_Form()">
        submit
      </button>
    </form>
  </div>

  <ng-template #appointmentSchduler>
    <div class="calendar-container">
      <div class="row">
        <p class="col-md-4 text-left"></p>
        <h4 class="col-md-4 text-center title">Appointment Calendar</h4>
        <i (click)="modalService.hide()" class="bi bi-x-circle calander-circle"></i>
        <!-- <button type="button" class="col-md-1 cancelBtn" (click)="modalService.hide()">cancel</button> -->
      </div>
      <div class="row mt-4">
        <div class="col-md-6 col-sm-6 col-xs-6 text-left">
          <h3 class="mt-0">
            {{
              viewDate
                | calendarSchedulerDate
                  : view + "ViewTitle"
                  : locale
                  : weekStartsOn
                  : excludeDays
                  : viewDays
                  : startsWithToday
            }}
          </h3>
          <!-- <select #viewDayOptionSelect1 class="form-control d-none d-md-block d-xl-none" [(ngModel)]="viewDays" (change)="viewDaysOptionChanged(viewDayOptionSelect1.value)">
                  <option [value]="1">Un giorno</option>
                  <option [value]="3">Tre giorni</option>
                  <option [value]="7">Una settimana</option>
              </select> -->
        </div>
        <div class="col-md-6 col-sm-6 col-xs-6 margintop text-right">
          <div class="row">
            <div
              class="col-6 d-md-none d-xl-flex col-xl-6 valign-center text-right"
            >
              <!-- <select #viewDayOptionSelect2 class="form-control m-1" [ngModel]="viewDays" (change)="viewDaysOptionChanged(viewDayOptionSelect2.value)">
                    <option [value]="1">Un giorno</option>
                    <option [value]="3">Tre giorni</option>
                    <option [value]="7">Una settimana</option>
                </select> -->
            </div>
            <div class="col-6 col-md-12 col-xl-6">
              <div class="btn-group m-1" role="group">
                <button
                  type="button"
                  class="btn btn-primary btnFont"
                  mwlCalendarPreviousView
                  [view]="view"
                  [(viewDate)]="viewDate"
                  [daysInWeek]="viewDays"
                  [excludeDays]="excludeDays"
                  [disabled]="prevBtnDisabled"
                  (viewDateChange)="dateOrViewChanged()"
                  (click)="getSchedular(viewDate)"
                >
                  <span class="valign-center">
                    <i class="bi bi-chevron-left">Previous</i>
                  </span>
                </button>
                <button
                  type="button"
                  class="btn btn-primary btnFont"
                  mwlCalendarToday
                  [(viewDate)]="viewDate"
                  (viewDateChange)="dateOrViewChanged()"
                  (click)="getSchedular(viewDate)"
                >
                  <span class="valign-center">
                    <i class="">Today</i>
                  </span>
                </button>
                <button
                  type="button"
                  class="btn btn-primary btnFont"
                  mwlCalendarNextView
                  [view]="view"
                  [(viewDate)]="viewDate"
                  [daysInWeek]="viewDays"
                  [excludeDays]="excludeDays"
                  [disabled]="nextBtnDisabled"
                  (viewDateChange)="dateOrViewChanged()"
                  (click)="getSchedular(viewDate)"
                >
                  <span class="valign-center">
                    <i class="bi bi-chevron-right">Next</i>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <calendar-scheduler-view
          [viewDays]="viewDays"
          [viewDate]="viewDate"
          [events]="events"
          [locale]="locale"
          [responsive]="false"
          [weekStartsOn]="weekStartsOn"
          [excludeDays]="excludeDays"
          [startsWithToday]="startsWithToday"
          [hourSegments]="hourSegments"
          [dayStartHour]="dayStartHour"
          [dayEndHour]="dayEndHour"
          [dayModifier]="dayModifier"
          [hourModifier]="hourModifier"
          [segmentModifier]="segmentModifier"
          [eventModifier]="eventModifier"
          [showEventActions]="true"
          [showSegmentHour]="true"
          [zoomEventOnHover]="true"
          (viewDaysChanged)="viewDaysChanged($event)"
          (dayHeaderClicked)="dayHeaderClicked($event.day)"
          (segmentClicked)="segmentClicked('Clicked', $event.segment)"
          (eventClicked)="eventClicked('Clicked', $event.event)"
          (eventTimesChanged)="eventTimesChanged($event)"
          [refresh]="refresh"
        >
        </calendar-scheduler-view>
      </div>
    </div>

    <!-- (hourClicked)="hourClicked($event.hour)" -->
  </ng-template>



  <ng-template #msg>
    <!-- Modal Header -->
    <div class="modal-header1">
      <h4 class="modal-title1">Message</h4>
      <!-- <button type="button" class="closeModal" data-dismiss="modal" (click)="modalService.hide()"><i
          class="bi bi-x-circle"></i></button> -->
    </div>
    <!-- Modal body -->
    <div class="modal-body">
      <p class="text-center">{{modalService.config.initialState.message}}</p>
    </div>
    <!-- Modal footer -->
    <div class="modal-footer1">
      <!-- <button type="button" class="btn btn-danger" (click)="modalClose()">CANCEL</button> -->
      <button type="button" class="btn-blue" (click)="modalService.hide()">OK</button>
    </div>

  </ng-template>





</div>
